import { useId } from '@uifabric/react-hooks';
import { Stack } from 'office-ui-fabric-react';
import React, { FunctionComponent } from 'react';
import { LinkProps } from 'react-router-dom';
import styled from 'styled-components';

import { BaseLinkCard } from '../BaseLinkCard/BaseLinkCard';
import { Body2Text, Caption2Text } from '../Typography/Typography';

export type IExploreNewOpportunitiesCardProps = {
  /**
   * Url of image
   */
  src: string;

  /**
   * Alt text for image
   */
  alt: string;

  /**
   * Title of card
   */
  title: string;

  /**
   * Subtitle
   */
  subtitle: string;

  /**
   * The classname
   */
  className?: string;

  /**
   * Footer
   */
  footerText?: string;

  onClick: () => void;
} & Pick<LinkProps, 'to' | 'target' | 'tabIndex' | 'replace'>;

const ScaleToFitImage = styled.img`
  width: auto;
  object-fit: cover;
  height: 100%;
  max-width: 50%;
`;

const StyledBaseCard = styled(BaseLinkCard)`
  height: 135px;
  width: 100%;
  display: flex;
  align-items: stretch;
`;

const StyledBodyLargeText = styled(Body2Text)`
  padding-bottom: 2px;
`;

const contentStackTokens = {
  padding: 16,
  maxHeight: '100%',
};

const ExploreNewOpportunitiesCard: FunctionComponent<IExploreNewOpportunitiesCardProps> = ({
  title,
  subtitle,
  footerText,
  src,
  alt,
  className,
  onClick,
  to,
  tabIndex,
  target,
  replace,
}) => {
  const titleId = useId('title');

  return (
    <StyledBaseCard
      onCardClick={onClick}
      className={className}
      to={to}
      tabIndex={tabIndex}
      target={target}
      replace={replace}
      aria-labelledby={titleId}
    >
      <ScaleToFitImage src={src} alt={alt} />
      <Stack tokens={contentStackTokens}>
        <StyledBodyLargeText className="highlight-on-card-hover" id={titleId}>
          {title}
        </StyledBodyLargeText>
        <Caption2Text>{subtitle}</Caption2Text>
        <Stack grow verticalAlign="end">
          <Caption2Text>{footerText}</Caption2Text>
        </Stack>
      </Stack>
    </StyledBaseCard>
  );
};

ExploreNewOpportunitiesCard.defaultProps = {
  src: '',
};

export { ExploreNewOpportunitiesCard };
